import React from 'react';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const bannerStatus = ({ status, link, spaceId }) => {
  const locale = SharedIntlProviderHOC.getLocale();
  const isEnLang = 'en' === locale.split('-')[0];
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  const bannerData = {
    UPDATE_REQUIRED: {
      icon: 'warning',
      background: 'bg-orange',
      header: <FormattedMessage id="hosting.space_banner_status.update_required_header" defaultMessage="Updates Needed"/>,
      body: <FormattedMessage id="hosting.space_banner_status.update_required_text" defaultMessage="You have required updates in order to move forward with your submission. Please view the updates needed and resubmit the space once requirements are complete."/>,
      button: {
        title: <FormattedMessage id="hosting.space_banner_status.update_required_button_text" defaultMessage="Updates Needed"/>,
        href: `https://hosts.peerspace.com/onboarding?space=${spaceId}`
      }
    },
    PENDING_REVIEW: {
      icon: 'info',
      background: 'bg-blue',
      header: <FormattedMessage id="hosting.space_banner_status.pending_review_header" defaultMessage="We have received your submission"/>,
      body: <div>
        <FormattedMessage
          id="hosting.space_banner_status.pending_review_text"
          defaultMessage="Your submission is currently under review by our host onboarding team. To avoid any delays in your activation, please review our {link}."
          values={{
            link:
            <a className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/209348086-What-are-the-requirements-for-live-listings-#:~:text=Host%20profiles%20must%20include%20their,include%20business%20or%20venue%20names`} target="_blank" rel="noreferrer noopener">
              <FormattedMessage id="hosting.space_banner_status.pending_review_go_live_link" defaultMessage="requirements to go live"/>
            </a>
          }}
        />
      </div>
    },
    PARKING_REQUIRED: {
      icon: 'warning',
      background: 'bg-orange',
      header: <FormattedMessage id="hosting.space_banner_status.parking_required_header" defaultMessage="New parking description requirement"/>,
      body: <FormattedMessage id="hosting.space_banner_status.parking_required_text" defaultMessage="Please complete the new parking description to help guests understand your parking availability."/>,
      button: {
        title: <FormattedMessage id="hosting.space_banner_status.parking_required_button_text" defaultMessage="Add Parking Info"/>,
        href: link
      }
    },
    ADD_CLEANING: {
      icon: null,
      background: 'bg-orange',
      header: <div className="text-green-200 text-small"><FormattedMessage id="hosting.space_banner_status.add_cleaning_header" defaultMessage="New"/></div>,
      headerClass: 'no-bottom-margin',
      body: <div className="heavy"><FormattedMessage id="hosting.space_banner_status.add_cleaning_text" defaultMessage="Add your cleaning process"/></div>,
      button: {
        title: <FormattedMessage id="hosting.space_banner_status.add_cleaning_button_text" defaultMessage="Add Details"/>,
        href: link
      }
    }
  };

  return get(bannerData, status, {});
};

export default bannerStatus;
